import user from './user'

const contexts =
{
    user
};

export default contexts ;
